document.addEventListener("DOMContentLoaded", function() {
  // Check if we're on a product page and the size guide link exists
  const sizeGuideLink = document.querySelector(".size-guide-link");
  if (sizeGuideLink) {
    const modal = document.querySelector(".product-popup-modal__content-info");
    const aElement = modal.querySelector("a");
    const imgElement = aElement.querySelector("img");
    const modalTitle = document.querySelector(".product-popup-modal__header .h2");
    const title = document.title; // Get the title of the webpage
    const collectionName = title.split(" ")[0]; // Extract the first word from the title
    const productTitle = document.querySelector(".product__title").textContent;
    let href, modalTitleText;

    if (collectionName === "Infernal" || collectionName === "Gheist") {
      if (productTitle.toLowerCase().includes("shirt")) {
        href = "https://cdn.shopify.com/s/files/1/0717/3380/5285/files/Infernal_Shirt_Size_Chart_Jun_v1.jpg?v=1750730672";
        modalTitleText = "T-Shirt Sizing Chart";
      }

      else if (productTitle.toLowerCase().includes("hoodie")) {
        href = "https://cdn.shopify.com/s/files/1/0717/3380/5285/files/gheist-hoodie-sizing.png?v=1757554071";
        modalTitleText = "Hoodie Sizing Chart";
      }
    }

    else if (collectionName === "Seasons") {
      if (productTitle.toLowerCase().includes("shirt")) {
        href = "https://cdn.shopify.com/s/files/1/0717/3380/5285/files/T-ShirtSizingChart.png?v=1735607308";
        modalTitleText = "T-Shirt Sizing Chart";
      }

      else if (productTitle.toLowerCase().includes("hoodie")) {
        href = "https://cdn.shopify.com/s/files/1/0717/3380/5285/files/hoodiesizechart.png?v=1731262915";
        modalTitleText = "Hoodie Sizing Chart";
      }

      else if (productTitle.toLowerCase().includes("underwear")) {
        href = "https://cdn.shopify.com/s/files/1/0717/3380/5285/files/seasons-underwear-sizing.jpg?v=1750735972";
        modalTitleText = "Underwear Sizing Chart";
      }
    }

    aElement.href = href;
    imgElement.src = href;
    modalTitle.textContent = modalTitleText;
  }
});
